<template>
    <div id="app">


        <!-- Navbar for mobile -->
        <div class="d-lg-none" v-if="$store.getUser()">

            <MobileNavbar />

        </div>

        <!-- Header -->
        <b-container class="header text-center">

            <img alt="Vue logo" src="@/assets/logo.png" class="logo">
            <!-- <h1>Teknobingo</h1> -->

        </b-container>

        <!-- Menu / View -->
        <b-container class="wrapper">
            <b-row>
                <b-col cols="12" lg="3" v-if="$store.getUser()" class="d-none d-lg-block">
                    <Nav />
                </b-col>
                <b-col>
                    <router-view />
                </b-col>
            </b-row>
        </b-container>


        <!-- Footer -->
        <b-container class="footer text-center">
            <p class="text-muted">
                <a href="/personvern">Personvern</a> | <a href="/betingelser">Betingelser</a> | <a href="#">Om Norskbingo.no</a>
            </p>

            <p class="text-muted">
                Norskbingo.no 2020
            </p>
        </b-container>


    </div>
</template>




<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import MobileNavbar from '@/components/MobileNavbar.vue'

export default {
    name: 'App',
    components: {
        Nav,
        MobileNavbar
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>


<style lang="scss">




#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;

    min-height: 100vh;
}


.header {
    padding-top: 40px;
}

@media only screen and (min-width: 576px) {
    .header {
        min-height: 150px;
    }
    .logo {
        height: 80px ;
    }
}

@media only screen and (max-width: 576px) {
    .logo {
        height: 40px ;
    }
}


.router-link-active {
    font-weight: 600;
}


.wrapper {
    padding-top: 30px;
    padding-bottom: 100px;
}
.footer {
    padding-top: 30px;
    padding-bottom: 30px;
}



#nav {
    padding: 30px;
    a {
        font-weight: bold;
        color: #2c3e50;
        &.router-link-exact-active {
            color: #C53B39;
        }
    }
}


.alert ul {
    margin-bottom: 0;
}
</style>
